
import { defineComponent, computed } from 'vue'

import { mdiChevronDown } from '@mdi/js'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'

export default defineComponent({
  components: { BaseSvgIcon },
  props: {
    isOpen: {
      type: Boolean,
      'default': () => (false),
    },
  },
  setup(props) {
    const switchOpenIcon = computed(() => {
      return props.isOpen ? 'rotate-0' : 'rotate-90'
    })

    return {
      mdiChevronDown,
      switchOpenIcon
    }
  },
})
